import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border: 1px solid ${({ theme }: { theme: Theme }) => theme.colors.input.border};
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.input.background};
  padding: 0 20px;
  outline: none;
  color: ${({ theme }: { theme: Theme }) => theme.colors.input.text};
  font-size: 18px;
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.gramatika};
  border-radius: 12px;

  &.error {
    border: 2px solid ${({ theme }: { theme: Theme }) => theme.colors.input.error.border};
    background-color: ${({ theme }: { theme: Theme }) => theme.colors.input.error.background};
  }

  &:not(&.error) {
    &:hover,
    &:focus,
    &:active,
    &:focus-within,
    &:not(:placeholder-shown) {
      border: 1px solid ${({ theme }: { theme: Theme }) => theme.colors.input.active.border};
      background-color: ${({ theme }: { theme: Theme }) => theme.colors.input.active.background};
    }
  }
`;
